import { useRef } from 'react';

import axios from "axios";

import { ApiClient } from 'services';

export const useCancellableClient = () => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();  const clientRef = useRef();
  if (!clientRef.current) {
    clientRef.current = ApiClient();
  }
  return {
    client: clientRef.current,
    cancel: source.cancel
  };
};

export default useCancellableClient;



// WEBPACK FOOTER //
// ./src/hooks/useCancellableClient.js